import { AbstractControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';
import { Attribute, Directive, ElementRef, forwardRef, Input } from '@angular/core';

@Directive({
  selector: '[appMin]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => MinDirective), multi: true }]
})
export class MinDirective implements Validator {
  @Input('min') min: string;
  constructor(private elementRef: ElementRef) {}

  validate(control: AbstractControl): { [key: string]: any } {
    return Validators.min(parseInt(this.min))(control);
  }
}
